import React, { useRef, useState } from 'react';
import { OpenDocuments } from './OpenDocuments';
import { useTranslation } from 'react-i18next';
import MoneyLabel from '../../label/MoneyLabel';
import { NewTransactionRelation } from '../../transactions/relations/NewTransactionRelation';
import { Typography } from '@mui/material';
import { updateOrCreate } from '../../special/updateOrCreate';
import { ReceiptPreviewElement } from '../../transactions/preview-elements/ReceiptPreviewElement';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';

export const OpenReceipts = () => {
  const { t } = useTranslation();
  const openDocumentsRef = useRef(null);
  const [selectedElement, setSelectedElement] = useState(null);

  const element = {
    label: t('Open receipts'),
    Icon: RequestQuoteIcon,
    apiUrl: 'receipts/open?openAmount[nq]=0',
    columns: [
      {
        header: t('Nr'), // header of column
        key: 'receiptNr', // key of column in row-object
        thAlign: 'left', // header text alignment
        tdAlign: 'left', // cell text alignment
        sortable: true, // enable sort function for column
        cell: ({ row }) => (
          <Typography className="monospace whitespace-nowrap">
            {row.receiptNr}
          </Typography>
        ), // custom xml for cells in the column. you get the row as object
        onClick: handleClick,
      },
      {
        header: t('Title'),
        key: 'title',
        width: '100%',
        thAlign: 'left',
        tdAlign: 'left',
        className: 'min-w-[250px]',
        sortable: true,
        onClick: handleClick,
      },
      {
        header: t('brutto'),
        key: 'openAmount',
        thAlign: 'right',
        tdAlign: 'right',
        width: '170px',
        sortable: true,
        cell: ({ row }) => (
          <Typography>
            <b>
              <MoneyLabel money={row.openAmount} />
            </b>
          </Typography>
        ),
        onClick: handleClick,
      },
    ],
  };

  function handleClick(row, col) {
    setSelectedElement(row);
  }

  function handleUpdatedElement(updatedElement) {
    openDocumentsRef.current.setApiData((prev) => {
      if (updatedElement.openAmount === 0)
        return {
          ...prev,
          data: prev.data.filter((obj) => obj.id !== updatedElement.id),
        };
      return updateOrCreate(prev, updatedElement);
    });
  }

  return (
    <>
      <OpenDocuments
        ref={openDocumentsRef}
        {...element}
        selectedElement={selectedElement}
      />
      <NewTransactionRelation
        open={Boolean(selectedElement)}
        RelationPreview={ReceiptPreviewElement}
        selectedElement={selectedElement}
        onClose={() => setSelectedElement(null)}
        relationType="receipt"
        transactionArrayKey="receipts"
        onUpdate={handleUpdatedElement}
      />
    </>
  );
};
